<template>
  <main>
    <div id="app" class="flex h-dvh overflow-y-hidden bg-white">
      <SideNav v-if="$store.state.user.user && $route.name !== 'Autenticação'" x-transition:enter="transition transform duration-300"
        x-transition:enter-start="-translate-x-full opacity-30  ease-in"
        x-transition:enter-end="translate-x-0 opacity-100 ease-out"
        x-transition:leave="transition transform duration-300"
        x-transition:leave-start="translate-x-0 opacity-100 ease-out"
        x-transition:leave-end="-translate-x-full opacity-0 ease-in"
        class="max-lg:hidden fixed inset-y-0 z-10 flex flex-col flex-shrink-0 w-64 max-h-screen overflow-hidden transition-all transform bg-white border-r shadow-lg lg:z-auto lg:static lg:shadow-none"
        :class="{ '-translate-x-full lg:translate-x-0 lg:w-16': !getshowSideNav }" />
      <!-- Barra de progresso de navegação: rotas lazy-loaded podem demorar em
           rede lenta; o delay de opacidade evita o flash em navegações rápidas -->
      <div class="route-progress fixed top-0 left-0 right-0 h-0.5 pointer-events-none"
        :class="{ 'route-progress--active': getRouteLoading }" style="z-index: 1000;">
        <div class="route-progress__bar h-full bg-blue-600"></div>
      </div>
      <div :class="getAlerts.length > 0 && 'space-y-1 sm:py-3'" class="fixed top-0 w-full" style="z-index: 999;">
        <AlertComponent v-for="(alert, index) in getAlerts" :key="index" :alert="alert" />
      </div>
      <router-view class="flex flex-col w-full flex-1 h-full overflow-x-hidden overflow-y-auto" />
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertComponent from '@/components/helper/AlertComponent.vue'
import SideNav from '@/components/SideNav';
import { isTokenExpired, refreshOrLogout } from '@/utils/session'

export default {
  name: 'App',
  components: {
    AlertComponent,
    SideNav
  },
  mounted() {
    // Renova a sessão em silêncio quando o access token expira, mesmo com a
    // aba parada (ao voltar o foco e num intervalo de 1 min). Só desloga se
    // o servidor recusar o refresh (sessão revogada ou inativa há muito tempo).
    this.checkSession();
    // Permissões do admin logado (esconde itens do menu e ações sem acesso)
    if (this.$store.state.user.user) this.$store.dispatch('fetchMyPermissions');
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    window.addEventListener('focus', this.checkSession);
    this.sessionInterval = setInterval(this.checkSession, 60000);
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    window.removeEventListener('focus', this.checkSession);
    clearInterval(this.sessionInterval);
  },
  methods: {
    onVisibilityChange() {
      if (!document.hidden) this.checkSession();
    },
    checkSession() {
      if (this.$store.state.user.user && isTokenExpired()) {
        refreshOrLogout().catch(() => {});
      }
    }
  },
  watch: {
    '$store.state.helpers.hideScrollBar': function () {
      if (this.$store.state.helpers.isMenuOpen) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = null
      }
    }
  },
  computed: {
    ...mapGetters(['getAlerts', 'getshowSideNav', 'getRouteLoading']),
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
}

body {
  display: flex;
  flex-direction: column;
  background-color: rgb(243 244 246);
}

.footer {
  flex-shrink: 0;
}

/* SCROLLBAR */
::-webkit-scrollbar {
  /* width */
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  /* Track */
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  /* Handle */
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: #555;
}

/* FIM SCROLLBAR */

li {
  list-style-type: none;
}

/* BARRA DE PROGRESSO DE NAVEGAÇÃO */
.route-progress {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.route-progress--active {
  opacity: 1;
  /* só aparece se a navegação demorar mais que 150ms */
  transition-delay: 0.15s;
}

.route-progress__bar {
  width: 0;
}

.route-progress--active .route-progress__bar {
  animation: route-progress-grow 1.8s cubic-bezier(0.2, 0.6, 0.3, 1) forwards;
}

@keyframes route-progress-grow {
  0% { width: 0; }
  50% { width: 60%; }
  100% { width: 92%; }
}

/* FIM BARRA DE PROGRESSO */
</style>
